import _ from 'lodash';
import EmptyRule from './components/rules/EmptyRule';
import NumberOfOrdersRule from './components/rules/NumberOfOrdersRule';
import ShippingFeesRule from './components/rules/ShippingFeesRule';
import UtilizationRule from './components/rules/UtilizationRule';
import OrderSizeRule from './components/rules/OrderSizeRule';
import OrderTimingRule from './components/rules/OrderTimingRule';
import PricingTierRule from './components/rules/PricingTierRule';
import MoreExpensiveVendorRule from './components/rules/MoreExpensiveVendorRule';
import PreferredSupplierRule from './components/rules/PreferredSupplierRule';
import DEAItemsRule from './components/rules/DEAItemsRule';
import DEADollarsRule from './components/rules/DEADollarsRule';
import ProductLineRule from './components/rules/ProductLineRule';
import PercentBudgetSpentRule from './components/rules/PercentBudgetSpentRule';
import PriceToInvoiceMismatchRule from './components/rules/PriceToInvoiceMismatchRule';
import PreferredItemGuidance from './components/guidance/PreferredItemGuidance';
import NonPreferredItemGuidance from './components/guidance/NonPreferredItemGuidance';
import NonPreferredSupplyGuidance from './components/guidance/NonPreferredSupplyGuidance';
import DelayPurchaseGuidance from './components/guidance/DelayPurchaseGuidance';
import EffectiveSupplierPriceGuidance from './components/guidance/EffectiveSupplierPriceGuidance';
import EffectiveItemPriceGuidance from './components/guidance/EffectiveItemPriceGuidance';
import EffectiveManufacturerPriceGuidance from './components/guidance/EffectiveManufacturerPriceGuidance';
import EffectivePriceGuidance from './components/guidance/EffectivePriceGuidance';
import ItemMessageGuidance from './components/guidance/ItemMessageGuidance';
import PercentBudgetSpentAlert from './components/alerts/PercentBudgetSpentAlert';
import ProductLinesAlert from './components/alerts/ProductLinesAlert';
import DEADollarsAlert from './components/alerts/DEADollarsAlert';
import DEAItemsAlert from './components/alerts/DEAItemsAlert';
import PreferredSupplierAlert from './components/alerts/PreferredSupplierAlert';
import MoreExpensiveVendorAlert from './components/alerts/MoreExpensiveVendorAlert';
import MoreExpensiveVendorFrequencyAlert from './components/alerts/MoreExpensiveVendorFrequencyAlert';
import PricingTierAlert from './components/alerts/PricingTierAlert';
import NumberOfOrdersAlert from './components/alerts/NumberOfOrdersAlert';
import OrderSizeAlert from './components/alerts/OrderSizeAlert';
import OrderTimingAlert from './components/alerts/OrderTimingAlert';
import UtilizationAlert from './components/alerts/UtilizationAlert';
import ShippingFeesAlert from './components/alerts/ShippingFeesAlert';
import BillMismatchAlert from './components/alerts/BillMismatchAlert';
import BillMismatchRule from './components/rules/BillMismatchRule';
import NewVendorAlert from './components/alerts/NewVendorAlert';
import NewVendorRule from './components/rules/NewVendorRule';
import InvoiceUnreceivedAlert from './components/alerts/InvoiceUnreceivedAlert';
import InvoiceNotGlCodedAlert from './components/alerts/InvoiceNotGlCodedAlert';
import InvoiceUnreceivedRule from './components/rules/InvoiceUnreceivedRule';
import InvoiceNotGlCodedRule from './components/rules/InvoiceNotGlCodedRule';
import OrderUnreceivedAlert from './components/alerts/OrderUnreceivedAlert';
import OrderUnreceivedRule from './components/rules/OrderUnreceivedRule';
import NoGLCodeRule from './components/rules/NoGLCodeRule';
import NoGLCodeAlert from './components/alerts/NoGLCodeAlert';
import ItemHasNoCorporateItemLinkAlert from './components/alerts/ItemHasNoCorporateItemLinkAlert';
import ItemHasNoCorporateItemLinkRule from './components/rules/ItemHasNoCorporateItemLinkRule';
import PendingClinicRule from './components/rules/PendingClinicRule';
import PendingClinicAlert from './components/alerts/PendingClinicAlert';
import StaleScriptRule from './components/rules/StaleScriptRule';
import StaleScriptAlert from './components/alerts/StaleScriptAlert';
import CredentialUnconnectedRule from './components/rules/CredentialUnconnectedRule';
import CredentialUnconnectedAlert from './components/alerts/CredentialUnconnectedAlert';
import WrongBillToRule from './components/rules/WrongBillToRule';
import WrongBillToAlert from './components/alerts/WrongBillToAlert';
import DisableAddToCartsGuidance from './components/guidance/DisableAddToCartsGuidance';
import PreferredSupplierGuidance from './components/guidance/PreferredSupplierGuidance';
import SecondarySupplierGuidance from './components/guidance/SecondarySupplierGuidance';


const defaultRule = { FormComponent: EmptyRule, AlertComponent: () => null };

const ALERT_RULES = [
  {
    title: 'Shipping Fees',
    subtitle: 'Accrues shipping fees over a specified limit',
    description: `Vetcove keeps track of any shipping fees charged to your hospital locations by distributors
                  or manufacturers. Set a monthly limit per location, and get alerted if a hospital has accrued
                  too many shipping fees in one calendar month.`,
    key: 'shipping_fees',
    FormComponent: ShippingFeesRule,
    AlertComponent: ShippingFeesAlert,
  },
  {
    title: 'Utilization',
    subtitle: 'Is not using Vetcove for their purchasing',
    description: `Vetcove tracks the percentage of orders in which usage of the Vetcove platform was involved
                  in the purchase. A low utilization means infrequent comparison shopping, and could lead to
                  suboptimal purchasing behaviors.`,
    key: 'utilization',
    FormComponent: UtilizationRule,
    AlertComponent: UtilizationAlert,
  },
  {
    title: 'Order Size',
    subtitle: 'Places a large order',
    description: `You can be alerted when a location places a very large order.  Set a dollar value over which
                  you’d like to be notified, and you’ll get an alert as soon as it happens.  This allows you
                  to review the order and take timely action if necessary.`,
    key: 'order_size',
    FormComponent: OrderSizeRule,
    AlertComponent: OrderSizeAlert,
  },
  {
    title: 'Order Timing',
    subtitle: 'Places a percentage of orders at an inappropriate time',
    description: `Many distribution partners work with their corporate groups to receive order placements before 
                 or after a certain time of day. Vetcove will alert you when a location places a percentage of 
                 its orders at a time that would not allow a rebate from the distribution partner.`,
    key: 'order_timing',
    FormComponent: OrderTimingRule,
    AlertComponent: OrderTimingAlert,
  },
  {
    title: 'Number of Orders',
    subtitle: 'Orders too frequently',
    description: `Many distribution partners work with their corporate groups to consolidate orders and reduce
                  order frequency. Vetcove will alert you if a location places more than a desired number of orders
                  in a single calendar month.`,
    key: 'number_of_orders',
    FormComponent: NumberOfOrdersRule,
    AlertComponent: NumberOfOrdersAlert,
  },
  {
    title: 'Pricing Tier',
    subtitle: 'Receives pricing that differs from the group',
    description: `If a hospital pays a higher price for a SKU than is typically paid by other locations in your
                  group, you can be alerted.  This indicates that a location may not be receiving your negotiated
                  group pricing and requires your attention.`,
    key: 'pricing_tier',
    FormComponent: PricingTierRule,
    AlertComponent: PricingTierAlert,
  },
  {
    title: 'Price to Invoice Mismatch',
    subtitle: 'Coming soon',
    description: 'Coming Soon!',
    key: 'price_to_invoice_mismatch',
    FormComponent: PriceToInvoiceMismatchRule,
    AlertComponent: defaultRule.AlertComponent,
    disabled: true,
  },
  {
    title: 'More Expensive Vendor',
    subtitle: 'Chooses more expensive vendors too frequently',
    description: `Vetcove records when locations choose a more expensive vendor when a cheaper option is available
                  for the same SKU.  You can be alerted when a location makes incorrect choices too frequently, or
                  results in a monthly dollar loss over a specified limit.`,
    key: 'more_expensive_vendor',
    FormComponent: MoreExpensiveVendorRule,
    AlertComponent: MoreExpensiveVendorAlert,
  },
  {
    title: 'More Expensive Vendor',
    subtitle: 'Chooses more expensive vendors too frequently',
    description: `Vetcove records when locations choose a more expensive vendor when a cheaper option is available
    for the same SKU.  You can be alerted when a location makes incorrect choices too frequently, or
    results in a monthly dollar loss over a specified limit.`,
    key: 'more_expensive_vendor_frequency',
    FormComponent: MoreExpensiveVendorRule,
    AlertComponent: MoreExpensiveVendorFrequencyAlert,
    disabled: true
  },
  {
    title: 'Preferred Supplier',
    subtitle: 'Does not meet partner compliance goals',
    description: `For partners whose products you’re looking to promote usage of, you can set a minimum percentage
                  by category, and get alerted when a location does not meet the minimum.  The percentage you set
                  do not need to reflect the agreed/target percentage. This alert will only trigger when the preferred
                  vendor is chosen less than the set percentage of the time **when they are an available option
                  for purchasing**.`,
    key: 'preferred_supplier',
    FormComponent: PreferredSupplierRule,
    AlertComponent: PreferredSupplierAlert,
  },
  {
    title: 'DEA Items',
    subtitle: 'Purchases a large number of DEA scheduled items',
    description: `You'll be alerted when a clinic places an order that contains a high quantity
                  of DEA-scheduled items. Just choose the minimum quantity and the DEA schedule.
                  Note that DEA schedule 1 is highest risk for abuse.`,
    key: 'dea_items',
    FormComponent: DEAItemsRule,
    AlertComponent: DEAItemsAlert,
  },
  {
    title: 'DEA Dollars',
    subtitle: 'Spends a lot on DEA scheduled items',
    description: `You'll be alerted when a clinic places an order that contains a high dollar
                  volume of DEA-scheduled items. Just choose the minimum quantity and the DEA schedule.
                  Note that DEA schedule 1 is highest risk for abuse.`,
    key: 'dea_dollars',
    FormComponent: DEADollarsRule,
    AlertComponent: DEADollarsAlert,
  },
  {
    title: 'Product Lines',
    subtitle: 'Purchases certain product lines',
    description: `You'll set up a group of products lines here (to create a product category) and be
                  alerted when a clinic orders too many different brands within that given product category`,
    key: 'product_lines',
    FormComponent: ProductLineRule,
    AlertComponent: ProductLinesAlert,
  },
  {
    title: 'Percent of Budget Spent',
    subtitle: 'Spent X% of their budget',
    description: 'Generate an alert whenever one of your clinics spends a certain percentage of their budget.',
    key: 'percent_budget_spent',
    FormComponent: PercentBudgetSpentRule,
    AlertComponent: PercentBudgetSpentAlert,
  },
  {
    title: 'Bill Mismatch',
    subtitle: 'Incorrect billing',
    description: `You can receive an alert when the billing address on a clinic's order
                  does not match your corporate billing address.`,
    key: 'bill_to_mismatch',
    FormComponent: BillMismatchRule,
    AlertComponent: BillMismatchAlert,
  },
  {
    title: 'New Vendor',
    subtitle: 'New vendor added after date',
    description: `You can receive an alert when a clinic adds a vendor after
                  your specified date.`,
    key: 'new_vendor',
    FormComponent: NewVendorRule,
    AlertComponent: NewVendorAlert,
  },
  {
    title: 'Pending Clinic',
    subtitle: 'A new clinic is pending approval',
    description: 'You can receive an alert when a new clinic has signed up and is pending approval.',
    key: 'pending_clinic',
    FormComponent: PendingClinicRule,
    AlertComponent: PendingClinicAlert
  },
  {
    title: 'Invoice Unreceived',
    subtitle: 'Invoice unreceived for x number of days',
    description: `You can receive an alert when a clinic has an unreceived
                  invoice for a specified number of days.`,
    key: 'invoice_unreceived',
    FormComponent: InvoiceUnreceivedRule,
    AlertComponent: InvoiceUnreceivedAlert,
  },
  {
    title: 'Order Unreceived',
    subtitle: 'Order unreceived for x number of days',
    description: `You can receive an alert when a clinic has an unreceived
                  order for a specified number of days.`,
    key: 'order_unreceived',
    FormComponent: OrderUnreceivedRule,
    AlertComponent: OrderUnreceivedAlert
  },
  {
    title: 'No GL Code',
    subtitle: 'Item purchased with no GL code',
    description: `You can receive an alert when a link
                  is created for an item with no GL code`,
    key: 'no_glcode',
    FormComponent: NoGLCodeRule,
    AlertComponent: NoGLCodeAlert,
  },
  {
    title: 'Unlinked Item',
    subtitle: 'Unlinked item was purchased',
    description: 'You can receive an alert when a clinic purchases an unlinked item.',
    key: 'has_no_item_link',
    FormComponent: ItemHasNoCorporateItemLinkRule,
    AlertComponent: ItemHasNoCorporateItemLinkAlert,
  },
  {
    title: 'Stale Script Request',
    subtitle: 'A script request was unresolved for x number of days',
    description: `You can receive an alert when a script request has not been resolved for
                  a specified number of days.`,
    key: 'stale_script',
    FormComponent: StaleScriptRule,
    AlertComponent: StaleScriptAlert,
  },
  {
    title: 'Invoice Not Gl Coded',
    subtitle: 'Not all items on an invoice have a gl code',
    description: `You can receive an alert when an invoice from
                   X or more days ago doesn't have gl codes for every item.`,
    key: 'invoice_not_glcoded',
    FormComponent: InvoiceNotGlCodedRule,
    AlertComponent: InvoiceNotGlCodedAlert,
  },
  {
    title: 'Vendor Account Unconnected',
    subtitle: 'A vendor account becomes unconnected',
    description: `You can receive an alert when the vendor account for a clinic
                  becomes unconnected.`,
    key: 'credential_unconnected',
    FormComponent: CredentialUnconnectedRule,
    AlertComponent: CredentialUnconnectedAlert,
  },
  {
    title: 'Wrong Bill To',
    subtitle: 'A clinic has placed an order with the wrong bill to',
    description: 'You can receive an alert when a clinic places an order with the wrong bill to.',
    key: 'wrong_bill_to',
    FormComponent: WrongBillToRule,
    AlertComponent: WrongBillToAlert
  }
];

const GUIDANCE_RULES = [
  {
    title: 'Preferred Items',
    subtitle: 'Display specific items as preferred by your group',
    description: `Vetcove enables you to indicate to clinics which items are preferred by your group. 
                  Preferred items will be given a boost in search results and be displayed with a preferred icon. 
                  Use the fields below to indicate which items should be shown as preferred by your group.`,
    key: 'preferred_item',
    FormComponent: PreferredItemGuidance,
  },
  {
    title: 'Non-Preferred Items',
    subtitle: 'Display specific items as non-preferred by your group',
    description: `Vetcove enables you to indicate which items are non-preferred by your group. Non-preferred items 
                  will be deprioritized in search results but will otherwise appear the same. You can also recommend
                  preferred alternatives by setting an item message redirecting to your group's preferred option. Use
                  the fields below to indicate which items are non-preferred by your group.`,
    key: 'non_preferred_item',
    FormComponent: NonPreferredItemGuidance,
  },
  {
    title: 'Preferred Suppliers',
    subtitle: 'Display specific suppliers as preferred by your group',
    description: `Vetcove enables you to indicate which supplier(s) your clinics should purchase their items from. 
                  Preferred suppliers will move to the top of the list of supplier options displayed to the right of 
                  an item listing. Use the fields below to specify your group's preferred supplier(s) 
                  for a set of items.`,
    key: 'preferred_supplier_guidance',
    FormComponent: PreferredSupplierGuidance,
  },
  {
    title: 'Secondary Suppliers',
    subtitle: 'Display specific suppliers as secondary for your group',
    description: `Vetcove enables you to indicate which supplier(s) your clinics should purchase their items from if 
                  they cannot purchase from your preferred supplier(s). Secondary suppliers will be displayed
                  underneath your preferred supplier(s) in the list of supplier options displayed to the right of an 
                  item listing. Use the fields below to specify your group's secondary supplier(s) for a set of items. 
                  Please note that you must have a preferred supplier(s) chosen for a given item for a secondary 
                  supplier to be highlighted.`,
    key: 'secondary_supplier_guidance',
    FormComponent: SecondarySupplierGuidance,
  },
  {
    title: 'Non-Preferred Suppliers',
    subtitle: 'Display specific suppliers as non-preferred by your group',
    description: `Vetcove enables you to indicate which supplier(s) your clinics should not purchase 
                  from when possible. Non-preferred suppliers will be moved to the bottom of the 
                  list of supplier options displayed to the right of an item listing. 
                  Use the fields below to specify which supplier(s) should be shown as 
                  non-preferred on a set of items.`,
    key: 'non_preferred_supply',
    FormComponent: NonPreferredSupplyGuidance,
  },
  {
    title: 'Order Timing',
    subtitle: 'Suggest changes to order dates to delay payments and improve cash flow',
    description: `Using a particular vendor’s billing cutoff date, you can gently suggest to purchasers to
                  hold off on expensive or nonessential items during the days leading up to the cutoff date.
                  This delays payments to the vendor and improves cash flow for the group.`,
    key: 'delay_purchase',
    FormComponent: DelayPurchaseGuidance,
  },
  {
    title: 'Effective Supplier Pricing',
    subtitle: 'Show true item cost to the group, after all rebates and incentives',
    description: `Many negotiated deals with distribution and manufacturing partners include fixed or
                  performance-based back end rebates. This option enables you to show effective pricing
                  (after rebates) to your purchasers, rather than pricing shown by the vendor.`,
    key: 'effective_supplier_price',
    FormComponent: EffectiveSupplierPriceGuidance,
  },
  {
    title: 'Effective Manufacturer Pricing',
    subtitle: 'Show true item cost to the group, after all rebates and incentives',
    description: `Many negotiated deals with distribution and manufacturing partners include fixed or
                  performance-based back end rebates. This option enables you to show effective pricing
                  (after rebates) to your purchasers, rather than pricing shown by the vendor.`,
    key: 'effective_manufacturer_price',
    FormComponent: EffectiveManufacturerPriceGuidance,
  },
  {
    title: 'Effective Item Pricing',
    subtitle: 'Show true item cost to the group, after all rebates and incentives',
    description: `Many negotiated deals with distribution and manufacturing partners include fixed or
                  performance-based back end rebates. This option enables you to show effective pricing
                  (after rebates) to your purchasers, rather than pricing shown by the vendor.`,
    key: 'effective_item_price',
    FormComponent: EffectiveItemPriceGuidance,
  },
  {
    title: 'Effective Price',
    subtitle: 'Show true item cost to the group, after all rebates and incentives',
    description: `This is an advanced rule composition. Please contact your corporate account representative
                  to help set up rules that involve combinations of suppliers, manufacturers, and items with
                  multiple inclusions and exclusions.`,
    key: 'effective_price',
    FormComponent: EffectivePriceGuidance,
  },
  {
    title: 'Item Message',
    subtitle: 'Show a message on a set of items',
    description: `You can display a message on any set of items, suppliers, or manufacturers in the Vetcove catalog.
                  For example, this guidance is useful if there are alternative products you would prefer
                  a clinic to buy, or alternative suppliers or manufacturers you would prefer a clinic to buy from.`,
    key: 'item_message',
    FormComponent: ItemMessageGuidance,
  },
  {
    title: 'Disable Add to Carts',
    subtitle: 'Prevent a clinic from adding an item to cart',
    description: `You can display a message on any set of items in the Vetcove catalog.
                  This will explain to clinics that these items should not be purchased.`,
    key: 'disable_add_to_carts',
    FormComponent: DisableAddToCartsGuidance,
  },
];

const RULES_LOOKUP = _.keyBy([...ALERT_RULES, ...GUIDANCE_RULES], 'key');

export const getRule = ruleKey => RULES_LOOKUP[ruleKey] || defaultRule;
export const getAlertRules = () => _.reject(ALERT_RULES, 'disabled');
export const getGuidanceRules = () => _.reject(GUIDANCE_RULES, 'disabled');
export const getNonCorporateGuidanceRules = () => [RULES_LOOKUP.preferred_item];
